
riot.tag2('geotargeting', '  <catalog object="GeoTargeting" cols="{cols}" reload="true" reorder="true" add="{add}" remove="{remove}" dblclick="{edit}" disable-col-select="true" limit="1000">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="address">{row.address}</datatable-cell>\n      <datatable-cell name="city">{row.city}</datatable-cell>\n      <datatable-cell name="phone">{row.phone}</datatable-cell>\n      <datatable-cell name="additionalPhones">{row.additionalPhones}</datatable-cell>\n      <datatable-cell name="url">{row.url}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'GeoTargeting';
self.handlers = {};

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'address', value: 'Адрес' }, { name: 'city', value: 'Город' }, { name: 'phone', value: 'Телефон' }, { name: 'additionalPhones', value: 'Доп. телефоны' }, { name: 'url', value: 'Домен' }];

self.add = function () {
    return riot.route('/settings/geotargeting/new');
};

self.edit = function (e) {
    return riot.route('settings/geotargeting/' + e.item.row.id);
};

observable.on('geotargeting-reload', function () {
    self.tags.catalog.reload();
});

self.one('updated', function () {
    self.tags.catalog.tags.datatable.on('reorder-end', function () {
        var _self$tags$catalog$pa = self.tags.catalog.pages,
            current = _self$tags$catalog$pa.current,
            limit = _self$tags$catalog$pa.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags.catalog.items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'GeoTargeting',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });
        self.update();
    });
});
});


// WEBPACK FOOTER //
// ./pages/settings/geotargeting/geotargeting.tag